// Enhanced Google Consent Signal Mapping (EGSM) — sc-41316
// Mirrors packages/builder-server/src/services/syncInjector/syncs/googleGtag/gtagConstants.ts
const EGSM = {
  ALWAYS_GRANTED: 'ALWAYS_GRANTED',
  ALWAYS_DENIED: 'ALWAYS_DENIED',
  NOT_SET: 'NOT_SET',
};

export default EGSM;

export const EGSM_ENABLED_FIELD = 'egsmEnabled';

// signal: gtag consent mode signal key (wire shape) / formField: parentGTag form field name
export const EGSM_SIGNALS = [
  { signal: 'ad_storage', formField: 'egsmAdStorage' },
  { signal: 'ad_user_data', formField: 'egsmAdUserData' },
  { signal: 'ad_personalization', formField: 'egsmAdPersonalization' },
  { signal: 'analytics_storage', formField: 'egsmAnalyticsStorage' },
];

export const EGSM_FIXED_OPTIONS = [
  { label: 'Always granted', value: EGSM.ALWAYS_GRANTED },
  { label: 'Always denied', value: EGSM.ALWAYS_DENIED },
  { label: 'Not set — unspecified', value: EGSM.NOT_SET },
];
